var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 59.531 59.531",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2b0000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: -3.0884e-8,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: -3.0884e-8,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146,
    fill: "#72cde3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146,
    fill: "#58c1da"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146,
    fill: "#aee3ef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 13.229,
    width: 6.6146,
    height: 6.6146,
    fill: "#85d4e7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 13.229,
    width: 6.6146,
    height: 6.6146,
    fill: "#72cde3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 13.229,
    width: 6.6146,
    height: 6.6146,
    fill: "#58c1da"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 13.229,
    width: 6.6146,
    height: 6.6146,
    fill: "#aee3ef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 13.229,
    width: 6.6146,
    height: 6.6146,
    fill: "#cdeef5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 19.844,
    width: 6.6146,
    height: 6.6146,
    fill: "#cdeef5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 19.844,
    width: 6.6146,
    height: 6.6146,
    fill: "#aee3ef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 19.844,
    width: 6.6146,
    height: 6.6146,
    fill: "#58c1da"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 19.844,
    width: 6.6146,
    height: 6.6146,
    fill: "#72cde3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 19.844,
    width: 6.6146,
    height: 6.6146,
    fill: "#85d4e7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 26.458,
    width: 6.6146,
    height: 6.6146,
    fill: "#85d4e7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 33.073,
    width: 6.6146,
    height: 6.6146,
    fill: "#79d0e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 26.458,
    width: 6.6146,
    height: 6.6146,
    fill: "#72cde3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 33.073,
    width: 6.6146,
    height: 6.6146,
    fill: "#66c9e1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 39.688,
    width: 6.6146,
    height: 6.6146,
    fill: "#66c9e1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#58c1da"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#aee3ef"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 26.458,
    width: 6.6146,
    height: 6.6146,
    fill: "#b5e5f0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.c0ce43fddad5498c52bed6c70d34e25d.svg";
export { ForwardRef as ReactComponent };